import { type FC, type ReactNode, type ChangeEventHandler } from 'react';
import { useIntl, defineMessages } from 'dibs-react-intl';

import { Input } from 'dibs-elements/exports/Input.tsx';

import fieldNames from '../../data/sellerApplicationFieldNames.json' with { type: 'json' };

const messages = defineMessages({
    city: {
        id: 'DealerApplicationForm.city.placeholder',
        defaultMessage: 'City',
    },
});

type Props = {
    onChange: ChangeEventHandler<HTMLInputElement>;
    errorMessage: ReactNode;
    value: string;
    disabled?: boolean;
};

const City: FC<Props> = ({ onChange, errorMessage, value, disabled }) => {
    const intl = useIntl();

    return (
        <Input
            placeholder={intl.formatMessage(messages.city)}
            hasAnimatedPlaceholder
            name={fieldNames.dealerInfo.city}
            dataTn="city"
            onChange={onChange}
            errorMessage={errorMessage}
            hasError={!!errorMessage}
            disabled={disabled}
            value={value}
        />
    );
};

export default City;
